// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rhyperior: PokeData = {
  "id": 464,
  "name": "rhyperior",
  "height": 24,
  "weight": 2828,
  "base_experience": 241,
  "types": [
    PokeType.GROUND,
    PokeType.ROCK
  ],
  "api_moves": [
    "stomp",
    "horn-attack",
    "fury-attack",
    "horn-drill",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "earthquake",
    "rock-slide",
    "scary-face",
    "megahorn",
    "rock-smash",
    "rock-blast",
    "hammer-arm",
    "poison-jab",
    "giga-impact",
    "rock-wrecker",
    "stone-edge",
    "stealth-rock",
    "smack-down",
    "chip-away",
    "bulldoze",
    "drill-run",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "earthquake",
    "rock-slide",
    "scary-face",
    "rock-smash",
    "rock-blast",
    "poison-jab",
    "stealth-rock",
    "rock-tomb",
    "seismic-toss",
    "mud-slap",
    "fissure",
    "stone-axe"
  ],
  "evolution_chain": {
    "id": 50,
    "item": null,
    "species": [
      {
        "name": "rhyhorn",
        "order": 123,
        "types": [
          PokeType.GROUND,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rhydon",
        "order": 124,
        "types": [
          PokeType.GROUND,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 111,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "rhyperior",
        "order": 125,
        "types": [
          PokeType.GROUND,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 112,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 146,
    "speed": 56,
    "ability_power": 197
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
